import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Eunomia Review admin module — `/eunomia/review` on
 * console.francisquini.ai. Admin UI for the shadow-draft curator.
 *
 * Lazy-loaded via the `@/routes/_app/eunomia-review` Suspense shim.
 * Introduced in T9.7.
 */
export const manifest: ModuleManifest = {
  module_id: 'eunomia-review',
  display_name: 'Eunomia Review',
  surface: 'admin',
  routes: [
    {
      path: '/eunomia/review',
      component: () =>
        import('@/routes/_app/eunomia-review').then((m) => ({
          default: m.EunomiaReviewPage,
        })),
      title: 'Eunomia Review',
      permissions: [],
    },
  ],
}
